import React from 'react';
import { motion } from 'framer-motion';
import { Star, Play } from 'lucide-react';
// ─────────────────────────────────────────────────────────────
// 👇 PEGÁ EL LINK DE YOUTUBE DE CADA TESTIMONIO EN "youtubeUrl"
//    Ejemplos válidos:
//      'https://www.youtube.com/watch?v=XXXXXXXXXXX'
//      'https://youtu.be/XXXXXXXXXXX'
//      'https://www.youtube.com/shorts/XXXXXXXXXXX'
//    Dejalo vacío ('') para seguir viendo el placeholder.
// ─────────────────────────────────────────────────────────────
type Testimonial = {
  text: string;
  hint: string;
  youtubeUrl: string;
};
const testimonials: Testimonial[] = [{
  text: 'Testimonio Andre',
  hint: 'Video del alumno',
  youtubeUrl: 'https://www.youtube.com/shorts/vKXqytTAMwc'
}, {
  text: 'Testimonio Caro',
  hint: 'Video del alumno',
  youtubeUrl: 'https://www.youtube.com/shorts/MwgDvGZ04LU'
}, {
  text: 'Testimonio Agus',
  hint: 'Video del alumno',
  youtubeUrl: 'https://www.youtube.com/shorts/jxSaLR24VqA'
}, {
  text: 'Testimonio Mari Argentina',
  hint: 'Video del alumno',
  youtubeUrl: 'https://www.youtube.com/shorts/iVAWoqgLQPk'
}];
/** Extrae el ID del video desde cualquier formato de link de YouTube */
function getYouTubeId(url: string): string | null {
  if (!url) return null;
  const match = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/);
  return match ? match[1] : null;
}
function TestimonialCard({
  item,
  index
}: {
  item: Testimonial;
  index: number;
}) {
  const videoId = getYouTubeId(item.youtubeUrl);
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    delay: index * 0.1
  }} className="bg-brand-card rounded-2xl p-6 border border-brand-border hover:border-brand-gold/30 transition-colors flex flex-col h-full" data-id="element-79">
      <div className="flex gap-1 mb-4" data-id="element-80">
        {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-81" />)}
      </div>

      {/* Slot de video — pegá el link de YouTube en "youtubeUrl" arriba */}
      <div className="w-full aspect-[4/5] rounded-xl mb-6 relative overflow-hidden border border-brand-border bg-brand-dark" data-id="element-82">
        {videoId ? <iframe className="absolute inset-0 w-full h-full" src={`https://www.youtube.com/embed/${videoId}`} title={item.text} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-id="element-83" /> : <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 bg-brand-gold/5 px-4 text-center" data-id="element-84">
            <div className="w-12 h-12 rounded-full bg-brand-gold/15 flex items-center justify-center" data-id="element-85">
              <Play className="w-6 h-6 text-brand-gold ml-0.5" data-id="element-86" />
            </div>
            <span className="text-brand-goldLight text-sm font-medium" data-id="element-87">
              Video de YouTube
            </span>
            <span className="text-brand-muted text-xs" data-id="element-88">
              Pegá el link en{' '}
              <span className="text-brand-goldLight font-semibold" data-id="element-89">
                youtubeUrl
              </span>
            </span>
          </div>}
      </div>

      <p className="text-brand-text/90 font-medium mt-auto" data-id="element-90">"{item.text}"</p>
    </motion.div>;
}
export function Testimonials() {
  return <section className="py-24 px-6 bg-brand-darker relative border-y border-brand-border" data-id="element-91">
      <div className="max-w-7xl mx-auto" data-id="element-92">
        <div className="text-center mb-16" data-id="element-93">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-bold mb-6" data-id="element-94">
            Personas reales.{' '}
            <span className="gold-gradient-text" data-id="element-95">Resultados reales.</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-brand-muted max-w-2xl mx-auto" data-id="element-96">
            Alumnos que decidieron dejar de postergar y empezaron a construir su
            tienda online con acompañamiento.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-97">
          {testimonials.map((item, i) => <TestimonialCard key={i} item={item} index={i} data-id="element-98" />)}
        </div>
      </div>
    </section>;
}